import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import {
  FaHome,
  FaQuestionCircle,
  FaBars,
  FaTimes,
  FaVolumeUp,
  FaVolumeMute,
} from "react-icons/fa";
import { useTranslation } from "react-i18next";
import "./Header.css";

const Header = ({ isPlaying, togglePlay }) => {
  const { t, i18n } = useTranslation();
  const languages = {
    en: "Eng",
    sc: "簡",
    tc: "繁",
  };

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isShrunk, setIsShrunk] = useState(false); // Added state for shrinking
  const [openDropdown, setOpenDropdown] = useState(null);

  const handleLangClick = (lang) => {
    i18n.changeLanguage(lang);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  const handleDropdownClick = (dropdownName) => {
    setOpenDropdown(openDropdown === dropdownName ? null : dropdownName);
  };

  // Effect to close dropdowns when main menu is closed
  useEffect(() => {
    if (!isMenuOpen) {
      setOpenDropdown(null);
    }
  }, [isMenuOpen]);

  // Effect for handling scroll to shrink header
  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      if (!isShrunk && currentScrollY > 100) {
        setIsShrunk(true);
      } else if (isShrunk && currentScrollY < 50) {
        setIsShrunk(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup the event listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [isShrunk]); // Re-run effect when isShrunk changes

  return (
    <header className={`header-container ${isShrunk ? "shrunk" : ""}`}>
      {" "}
      {/* Conditionally apply 'shrunk' class */}
      <div className="header-content">
        <div className="header-top">
          <div className="header-top-left"></div>
          <div className="logo">
            <Link to="/" className="logo-link" onClick={closeMenu}>
              <img
                src="/images/one_oasis_logo.png"
                alt="One Oasis Logo"
                className="logo-img"
              />
            </Link>
          </div>
          <div className="header-right">
            <div className="enquiry-button">
              <a href="/contact/sales-contact">
                <span>{t("make_an_enquiry")}</span>
              </a>
            </div>
            <div className="hamburger" onClick={toggleMenu}>
              {isMenuOpen ? <FaTimes /> : <FaBars />}
            </div>
          </div>
        </div>
        <div className={`header-bottom ${isMenuOpen ? "open" : ""}`}>
          <nav className="navigation">
            <NavLink
              to="/"
              className={({ isActive }) =>
                "home-icon" + (isActive ? " active" : "")
              }
              onClick={closeMenu}
            >
              <FaHome />
            </NavLink>

            <div className="nav-item dropdown-container">
              <div
                className="nav-link-non-clickable"
                onClick={() => handleDropdownClick("LOCATION")}
              >
                {t("nav_location")}
              </div>
              <div
                className={`dropdown-menu ${
                  openDropdown === "LOCATION" ? "open" : ""
                }`}
              >
                <NavLink to="/location/macau" onClick={closeMenu}>
                  {t("dd_macau")}
                </NavLink>
                <NavLink to="/location/one-oasis" onClick={closeMenu}>
                  {t("dd_one_oasis")}
                </NavLink>
                <NavLink to="/location/neighborhood" onClick={closeMenu}>
                  {t("dd_neighborhood")}
                </NavLink>
              </div>
            </div>

            <div className="nav-item dropdown-container">
              <div
                className="nav-link-non-clickable"
                onClick={() => handleDropdownClick("RESIDENCE")}
              >
                {t("nav_residence")}
              </div>
              <div
                className={`dropdown-menu ${
                  openDropdown === "RESIDENCE" ? "open" : ""
                }`}
              >
                <NavLink to="/residence/apartments-plans" onClick={closeMenu}>
                  {t("dd_apartments_plans")}
                </NavLink>
                <NavLink to="/residence/design-material" onClick={closeMenu}>
                  {t("dd_design_material")}
                </NavLink>
                
                
                <NavLink
                  to="/residence/property-management"
                  onClick={closeMenu}
                >
                  {t("dd_property_management")}
                </NavLink>
                
                {/*
                <NavLink
                  to="/residence/established-community"
                  onClick={closeMenu}
                >
                  {t("dd_established_community")}
                </NavLink>
                */}
                 
              
                
              </div>
            </div>

            <div className="nav-item dropdown-container">
              <div
                className="nav-link-non-clickable"
                onClick={() => handleDropdownClick("AMENITIES")}
              >
                {t("nav_amenities")}
              </div>
              <div
                className={`dropdown-menu ${
                  openDropdown === "AMENITIES" ? "open" : ""
                }`}
              >
                <NavLink to="/amenities/clubhouse" onClick={closeMenu}>
                  {t("dd_clubhouse")}
                </NavLink>
                <NavLink to="/amenities/retail" onClick={closeMenu}>
                  {t("dd_retail")}
                </NavLink>
                <NavLink
                  to="/amenities/international-schools"
                  onClick={closeMenu}
                >
                  {t("dd_international_schools")}
                </NavLink>
              </div>
            </div>

            <div className="nav-item dropdown-container">
              <NavLink
                to="/gallery"
                className={({ isActive }) => (isActive ? "active" : "")}
                onClick={closeMenu}
              >
                {t("nav_gallery")}
              </NavLink>
            </div>
            {/*
            <div className="nav-item dropdown-container">
              <div className="nav-link-non-clickable" onClick={() => handleDropdownClick('GALLERY')}>GALLERY</div>
                 <div className={`dropdown-menu ${openDropdown === 'GALLERY' ? 'open' : ''}`}>
                <NavLink to="/gallery/residences" onClick={closeMenu}>Residences</NavLink>
                <NavLink to="/gallery/amenities" onClick={closeMenu}>Amenities</NavLink>
                <NavLink to="/gallery/neighborhood" onClick={closeMenu}>Neighborhood</NavLink> 
                
              </div>
          
            </div>
                */}
            <div className="nav-item dropdown-container">
              <NavLink
                to="/awards"
                className={({ isActive }) => (isActive ? "active" : "")}
                onClick={closeMenu}
              >
                {t("nav_awards")}
              </NavLink>
            </div>

            <div className="nav-item dropdown-container">
              <div
                className="nav-link-non-clickable"
                onClick={() => handleDropdownClick("CONTACT")}
              >
                {t("nav_contact")}
              </div>
              <div
                className={`dropdown-menu ${
                  openDropdown === "CONTACT" ? "open" : ""
                }`}
              >
                <NavLink to="/contact/sales-contact" onClick={closeMenu}>
                  {t("dd_sales_contact")}
                </NavLink>
                <NavLink to="/contact/developers" onClick={closeMenu}>
                  {t("dd_developers")}
                </NavLink>
              </div>
            </div>

            <div className="language-links">
              {Object.keys(languages)
                .filter((lang) => lang !== i18n.language)
                .map((lang) => (
                  <span
                    key={lang}
                    onClick={() => {
                      handleLangClick(lang);
                      closeMenu();
                    }}
                    className="language-link"
                  >
                    {languages[lang]}
                  </span>
                ))}
            </div>
            <div className="audio-toggle" onClick={togglePlay}>
              {isPlaying ? <FaVolumeUp /> : <FaVolumeMute />}
            </div>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
